import React, { useState } from 'react';
import CustomDialog from '../../utils/CustomDialog';
import { baseButtonStyle } from '../Styles';
import { Button } from '@mui/material';

const DisableMonitoringButton = (props) => {
  const { buttonLabel, dialogTitle, dialogContent, onConfirm, disableButton } = props;
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = async () => {
    await onConfirm();
    handleClose();
  };

  return (
    <>
      <Button
        id="identity-disable-monitoring-button"
        label={buttonLabel}
        size="medium"
        sx={{...baseButtonStyle()}}
        onClick={handleClickOpen}
        disabled={disableButton}
      >
        {buttonLabel}
      </Button>      
      <CustomDialog
        openDialog={open}
        closeDialog={handleClose}
        title={dialogTitle}
        content={dialogContent}
        handleSubmit={handleConfirm}
        submitBtnTitle="Confirm"
        hideDivider={true}
        {...props}
      />
    </>
  );
};

export default DisableMonitoringButton;
